<div class="info-block">
  <h5 class="info-block__title">{{ title }}</h5>
  <div class="info-block__text">
    <span *ngFor="let item of items">
      {{ item.label }}
      @if (item.link) {
        <a class="info-block__link" [routerLink]="item.link">{{ item.value }}</a>
      } @else {
        <b>{{ item.value }}</b>
      }
    </span>
  </div>
</div>
